export default "__VITE_ASSET__DoEOoRXS__"